import { gql } from "@apollo/client"
// Define the mutation

export const UPDATE_JOB_STATUS_MUTATION = gql`
    mutation UpdateJob($id: MongoID, $record: JobRecordInput) {
        updateJob(_id: $id, record: $record) {
            record {
                _id
                jobStatus
                items {
                    quantity
                    quantityLoaded
                    quantityUnloaded
                    _id
                    itemId
                }
                customFields {
                    customFieldTemplateId
                    value
                }
            }
        }
    }
`

// Define the mutation
export const CREATE_DOCUMENT_TYPE_MUTATION = gql`
    mutation CreateDocumentType($record: CreateOneDocumentTypeInput!) {
        createDocumentType(record: $record) {
            record {
                name
                description
                _id
            }
        }
    }
`

export const CREATE_DOCUMENT_MUTATION = gql`
    mutation CreateDocument($record: CreateOneDocumentInput!) {
        createDocument(record: $record) {
            uploadUrl
        }
    }
`

export const BULK_UPDATE_JOBS = gql`
    mutation BulkUpdateJobs($jobIds: [MongoID]!, $jobStatus: EnumJobStatus) {
        bulkUpdateJobs(jobIds: $jobIds, jobStatus: $jobStatus) {
            _id
            jobStatus
        }
    }
`
